import { InjectionToken } from '@angular/core';

import { CurrentUserAndPermissions } from './current-user-and-permissions';

export const CURRENT_USER = new InjectionToken<CurrentUserAndPermissions>(
  'app.currentUser',
);
